import PropTypes from 'prop-types'
import { applyMiddleware, middlewares } from '../middleware'
import { initialState, rootReducer } from '../reducers'
import React, { createContext, useReducer, useRef, useContext, useEffect, useCallback, useMemo } from 'react'

export const AppContext = createContext()

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(rootReducer, initialState)
  const currentStateRef = useRef(initialState)

  useEffect(() => {
    currentStateRef.current = state
  }, [state])

  const getState = useCallback(() => currentStateRef.current, [])
  const enhancedDispatch = useMemo(() => applyMiddleware(dispatch, getState, middlewares), [dispatch, getState])
  const contextValue = useMemo(() => ({ state, dispatch: enhancedDispatch }), [state, enhancedDispatch])

  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  )
}

AppProvider.propTypes = {
  children: PropTypes.node.isRequired
}
// Hook that components can use to access the context
export const useAppContext = () => useContext(AppContext)
